<!-- //
数据源选择器
@auth xuyd
@date 2024-05-04
//-->
<template>
  <el-select
      v-model="datasourceType"
      placeholder="请选择数据源类型"
      clearable
      style="width: 100%"
      @change="handleChange"
    >
    <el-option
        v-for="item in list"
        :key="item.value"
        :label="item.label"
        :value="item.value">
    </el-option>
  </el-select>
</template>

<script>

export default {
  name: 'SelectDatasourceType',
  data() {
    return {
      datasourceType: null,
    }
  },
  model: {
    prop: "value",
    event: "change"
  },
  props:{
    value: [String, Number],
    list: Array,
  },
  watch: {
    value: {
      handler: function (val) {
        this.datasourceType = val;
      },
      immediate: true
    },
  },
  methods: {
    handleChange(val) {
      this.$emit('change', val);
    }
  }
}
</script>

<style lang="less" scoped>
</style>

